<template lang="html">
  <div>
    <v-app-bar app flat color="white" height="72">
      <v-container class="px-0">
        <v-row>
          <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
            <div class="d-flex align-center">
              <v-btn icon width="40" height="40" class="mr-2" @click="goBack()">
                <v-icon>
                  mdi-arrow-left
                </v-icon>
              </v-btn>
              <div class="title-page-text">
                {{ $t('v2.redeem_point') }}
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>
    <v-container class="pt-0">
      <v-row>
        <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="pt-0">
          <div class="mt-2">
            <div class="pa-4 ol-elevation-2 br-8">
              <div class="flex-image">
                <div class="flex-image-avatar mr-2">
                  <img src="@/assets/images/v2/img/icon_point.png" alt="Voucher" class="image-22">
                </div>
                <div class="flex-image-content">
                  <div class="flex-image-content-text font-12 font-weight-400 ol-grey-content">
                    {{ $t('v2.you_have') }}
                  </div>
                  <div class="flex-image-content-text font-14 font-weight-600 ol-black">
                    {{ Number(customer.join_loyalty_points) }} pts
                  </div>
                </div>
              </div>
            </div>
          </div>
          <template v-if="points.length > 0">
            <div class="mt-10">
              <div class="font-18 font-weight-700">
                {{ $t('v2.vouchers_available') }}
              </div>
            </div>
            <div v-scroll="onScrollItem" class="list-with-border">
              <div v-for="(point, i) in points" :key="i" class="list-item-with-border flex-image py-6 px-4 cursor-pointer">
                <div class="flex-image-avatar mr-2">
                  <template v-if="point.type === 'D'">
                    <img v-if="point.can_be_used" src="@/assets/images/v2/img/icon_discount.png" alt="Voucher">
                    <img v-else src="@/assets/images/v2/img/icon_discount_disable.png" alt="Voucher">
                  </template>
                  <template v-else>
                    <img v-if="point.photo" :src="point.photo" alt="Voucher" :class="['image-40 br-5', {'image-grayscale': !point.can_be_used }]" @error="imageLoadError">
                    <img v-else src="@/assets/images/product_not_available.png" alt="Voucher" :class="['image-40 br-5', {'image-grayscale': !point.can_be_used }]" @error="imageLoadError">
                  </template>
                </div>
                <div class="flex-image-content">
                  <div class="flex-image-content-text font-14 font-weight-600 ol-black line-height-normal two-line">
                    <template v-if="point.type === 'D'">
                      {{ $t('v2.discount') }}
                      <span v-if="Number(point.discount_amount) === 0">
                        {{ point.discount_rate }}%
                      </span>
                      <span v-else v-mask-money="point.discount_amount" />
                    </template>
                    <template v-else>
                      {{ Number(point.qty) }}x {{ $t('v2.free') }} {{ point.product_name }} {{ point.product_variant_id ? ' - ' + point.product_variant_name : '' }}
                    </template>
                  </div>
                  <div :class="['flex-image-content-text font-12 font-weight-400 line-height-normal', !point.can_be_used && point.cannot_be_used.length > 0 ? 'ol-red' : 'ol-grey-content']">
                    {{ Number(point.redeemed_points) }} pts
                  </div>
                </div>
                <div class="ml-2">
                  <v-btn color="primary" height="37" :disabled="!point.can_be_used" class="white--text text-none elevation-0 font-14 br-5 letter-spacing-normal" @click.stop="hitPoint(point)">
                    {{ $t('v2.redeem') }}
                  </v-btn>
                </div>
              </div>
            </div>
          </template>
          <div v-else class="text-center mt-4">
            <div class="mb-2">
              <svg width="90" height="90" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="6" y="30" width="78" height="36" rx="6" fill="#767676" />
                <rect y="24" width="90" height="38" rx="6" fill="#CECECE" />
                <rect x="7" y="30" width="34" height="7" rx="3.5" fill="#767676" />
                <rect x="7" y="42" width="34" height="2" rx="1" fill="#767676" />
                <path d="M58 30H78C81.3137 30 84 32.6863 84 36V50C84 53.3137 81.3137 56 78 56H58V30Z" fill="#767676" />
              </svg>
            </div>
            <div class="font-18 font-weight-700">
              {{ $t('v2.vouchers_not_available') }}
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { debounce } from 'debounce'
import { mapGetters } from 'vuex'
import {
  hitPoint as hitDataPoint,
  getDataValidate as getDataPoint
} from '@/api/point'
import {
  getData as getCustomer
} from '@/api/customer'
export default {
  data() {
    return {
      customer: {},
      points: [],
      params: {
        page: 1,
        per_page: 10
      },
      settingScroll: {
        point: false
      },
      cart: {}
    }
  },
  computed: {
    ...mapGetters(['notSystem']),
    dataParams() {
      var params = {
        page: this.params.page,
        per_page: this.params.per_page
      }
      // if (this.params.search_column.length > 0) {
      //   params.search_column = this.params.search_column
      //   params.search_operator = this.params.search_operator
      //   params.search_text = this.params.search_text
      // }
      return params
    },
    data_cart() {
      if (this.cart.item && this.cart.item.length > 0) {
        return this.cart.item.reduce((acc, curr) => {
          return {
            qty: acc.qty + curr.qty,
            sub_total: (typeof acc.sub_total !== 'undefined' ? acc.sub_total : 0) + (typeof curr.sub_total !== 'undefined' ? curr.sub_total : 0)
          }
        })
      } else {
        return {
          qty: 0,
          sub_total: 0
        }
      }
    }
  },
  mounted() {
    const LOCAL_DATA_CART = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_v2_cart')
    if (LOCAL_DATA_CART) {
      this.cart = JSON.parse(LOCAL_DATA_CART)
    }
    if (this.notSystem) {
      this.getDataCustomer()
    }
    this.fetchPoints()
  },
  methods: {
    imageLoadError(event) {
      event.target.src = require('@/assets/images/product_not_available.png')
    },
    goBack() {
      this.$router.push({ name: '_checkout' }).catch(() => {})
    },
    onScrollItem() {
      this.scrollLoadPoint()
    },
    scrollLoadPoint: debounce(async function() {
      if (this.settingScroll.point === false) {
        if ((window.innerHeight + window.scrollY + 100) >= document.body.offsetHeight) {
          this.fetchPoints()
        }
      }
    }, 500),
    async getDataCustomer() {
      try {
        const { data } = await getCustomer()
        this.customer = data.data
      } catch (e) {
        this.customer = {}
      }
    },
    async fetchPoints() {
      try {
        const { data } = await getDataPoint(this.cart, this.dataParams)
        this.settingScroll.point = (data.data.length < this.params.per_page)
        for (var i in data.data) {
          this.points.push(data.data[i])
        }
        this.params.page++
      } catch (e) {
        this.settingScroll.point = true
        this.points = []
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
    },
    async hitPoint(item) {
      const data_hit = { ...this.cart }
      data_hit.redeem_id = item.id
      data_hit.remark = this.$store.state.selected_type
      const arrItem = [...this.cart.item]
      if (item.type === 'P') {
        arrItem.push({
          product_id: item.product_id,
          product_variant_id: item.product_variant_id,
          qty: Number(item.qty),
          note: 'REDEEMED'
        })
      }
      data_hit.item = arrItem
      try {
        const { data } = await hitDataPoint(data_hit)
        this.cart.requestId = data.requestId
        this.cart.redeemId = item.id
        this.cart.point_detail = item
        if (item.type === 'P') {
          this.cart.item.push({
            product_type: 'point',
            product_id: item.product_id,
            product_variant_id: item.product_variant_id,
            qty: Number(item.qty),
            note: 'REDEEMED'
          })
        } else {
          var total = this.data_cart.sub_total
          var voucher_discount = 0
          if (typeof this.cart.discount_voucher_id !== 'undefined' && typeof this.cart.discount_detail !== 'undefined' && !this.$isEmpty(this.cart.discount_detail)) {
            voucher_discount = total < Number(this.cart.discount_detail.discount_to_amount) ? total : Number(this.cart.discount_detail.discount_to_amount)
            total = total - voucher_discount
          }
          if (Number(this.cart.point_detail.discount_amount) >= total) {
            this.$router.push({ name: '_checkout' }).catch(() => {})
            this.$store.state.show_error = true
            this.$store.state.error_message = this.$t('v2.minimum_subtotal_is_not_sufficient')
            this.$store.state.error_type = 406
            return
          }
        }
        await this.$store.dispatch('saveCartV2', this.cart)
        this.$router.push({ name: '_checkout' }).catch(() => {})
        this.$store.state.show_error = true
        this.$store.state.error_message = this.$t('v2.points_successfully_exchanged')
        this.$store.state.error_type = 200
      } catch (e) {
        if (e.statusCode === 401) {
          this.$store.dispatch('fetchToken')
        } else {
          this.$store.state.show_error = true
          this.$store.state.error_message = e.string
          this.$store.state.error_type = e.statusCode
        }
      }
    }
  }
}
</script>
